export const ROW_CHECK_OPTIONS = {
  role: "role",
  unit: "unit",
  type: "type",
  period: "period",
  status: "status",
  DealerName: "DealerName",
};
